import React, { Component } from 'react';
import { Grid, IconButton } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { IndeterminateCheckBoxOutlined, AddBoxOutlined } from '@material-ui/icons';
import { connect } from 'react-redux';
import CompanyIcon from '../../../image/Building.svg';
import OfficeIcon from '../../../image/Office.svg';
import AreaIcon from '../../../image/Japan.svg';
import PrefIcon from '../../../image/Map_base.svg';
import {
  HIERARCHY_KBN,
  EXISTS,
  TREE_LEVEL,
  CONTRACT_LABEL,
} from '../../../common/const';

/**
 * ツリーリストコンポーネント
 */
class CompanyTreeItemComponent extends Component {
  constructor() {
    super();
    this.state = {
      childOpen: true,
      officeOpen: false,
    };
  }

  componentDidMount() {
    const {
      tabType,
      level,
    } = this.props;

    // 選択タブが地域階層かつツリー階層が都道府県の場合、初期表示時は事業所を非表示
    if (tabType === HIERARCHY_KBN.AREA
      && level === TREE_LEVEL.PREF) {
      this.setState({ childOpen: false });
    }
  }

  componentDidUpdate(preProps) {
    const { item } = this.props;
    if (item && item !== preProps.item) {
      this.initState();
    }
  }

  initState = () => {
    this.setState({
      childOpen: true,
      officeOpen: false,
    });
  }

  /**
   * 開く/閉じるアイコンの制御イベント
   */
  onClickChild = () => {
    const { childOpen } = this.state;
    this.setState({ childOpen: !childOpen });
  }

  /**
   * 開く/閉じるリンクの制御イベント
   */
  onClickOffice = async (kigyoCode, level) => {
    const { officeOpen } = this.state;
    const { setTreeOfficeList } = this.props;
    // リンク名「開く」押下 ⇒ 「閉じる」の場合、事業所一覧を取得
    if (!officeOpen) {
      // TreeListのメソッドを呼ぶ
      await setTreeOfficeList(kigyoCode, level);
    }
    this.setState({ officeOpen: !officeOpen });
  }

  /**
   * 取引情報リンクのポップアップ表示イベント
   */
  onClickAdditionalItem = async (item) => {
    const { setAdditionalItemList } = this.props;
    await setAdditionalItemList(item);
  }

  render() {
    const {
      item,
      tabType,
      level,
      id,
      userInfo,
      contractLabel,
      setSelectTreeItem,
      setTreeOfficeList,
      setAdditionalItemList,
      selectedCompanyInfo,
    } = this.props;

    // 企業/事業所リストの1レコードがない場合、何も表示しない
    if (!item || Object.keys(item).length === 0) {
      return null;
    }

    const {
      childOpen,
      officeOpen,
    } = this.state;

    let officeList = null;

    // 事業所リストが存在、かつ事業所を表示する場合
    if (item.office_list && item.office_list.length > 0) {
      let officeListClassName = null;
      if (item.child_list && item.child_list.length > 0) {
        if (childOpen) {
          officeListClassName = 'officelist-border';
        } else {
          officeListClassName = 'officelist-border officelist-close';
        }
      } else {
        officeListClassName = 'officelist-border officelist-none';
      }
      // officeOpenがTRUEの場合、ツリーリストコンポーネントを呼び出す
      officeList = officeOpen ? (
        <ul className="officelist">
          <li className={officeListClassName}>
            <ul className="officeListItem">
              {// 事務所リストの件数分ツリーリストコンポーネントの呼び出しを行う
                item.office_list.map((office, index) => {
                  const nextLevel = TREE_LEVEL.OFFICE;
                  const nextId = `${id}-${index}-${nextLevel}`;
                  return (
                    <CompanyTreeItemComponent
                      key={nextId}
                      // 選択したタブ(企業階層、出資率50%超、地域階層)
                      tabType={tabType}
                      // ツリーの階層(必ず最下層なので、固定で9を設定)
                      level={nextLevel}
                      // レコードの識別子
                      id={nextId}
                      // 事業所リスト
                      item={office}
                      // 選択中企業企業情報をセットする関数
                      setSelectTreeItem={setSelectTreeItem}
                      // ツリーで選択したItemの事業所一覧を取得する関数
                      setTreeOfficeList={setTreeOfficeList}
                      // 選択企業情報
                      selectedCompanyInfo={selectedCompanyInfo}
                      // 取引情報ポップアップ画面を表示する関数
                      setAdditionalItemList={setAdditionalItemList}
                      // userInfo
                      userInfo={userInfo}
                      // 契約ラベル
                      contractLabel={contractLabel}
                    />
                  );
                })
              }
            </ul>
          </li>
        </ul>
      ) : (<ul className="officelist" />);
    }

    let childList = null;
    if (item.child_list && item.child_list.length > 0) {
      // childOpenがTRUEの場合、ツリーリストコンポーネントを呼び出す
      childList = childOpen ? (
        <ul className="officeListItem">
          {// 子リストの件数分ツリーリストコンポーネントの呼び出しを行う
            childList = item.child_list.map((child, index) => {
              const nextLevel = level + 1;
              const nextId = `${id}-${index}-${nextLevel}`;
              return (
                <CompanyTreeItemComponent
                  key={nextId}
                  // 選択したタブ(企業階層、出資率50%超、地域階層)
                  tabType={tabType}
                  // ツリーの階層(子の階層なので、親の階層+1を設定)
                  level={nextLevel}
                  // レコードの識別子
                  id={nextId}
                  // 企業/事業所リスト
                  item={child}
                  // 選択中企業企業情報をセットする関数
                  setSelectTreeItem={setSelectTreeItem}
                  // ツリーで選択したItemの事業所一覧を取得する関数
                  setTreeOfficeList={setTreeOfficeList}
                  // 選択企業情報
                  selectedCompanyInfo={selectedCompanyInfo}
                  // 取引情報ポップアップ画面を表示する関数
                  setAdditionalItemList={setAdditionalItemList}
                  // userInfo
                  userInfo={userInfo}
                  // 契約ラベル
                  contractLabel={contractLabel}
                />
              );
            })
          }
        </ul>
      ) : (<ul />);
    }

    let icon = null;

    // 選択されたタブが企業階層の場合
    if (tabType === HIERARCHY_KBN.COMPANY) {
      // 最初の階層は「企業アイコン」、その他は「事業所アイコン」を設定
      icon = level === TREE_LEVEL.FIRST ? CompanyIcon : OfficeIcon;
      // 選択されたタブが出資率50%超の場合
    } else if (tabType === HIERARCHY_KBN.FUND) {
      // 最後の階層は「事業所アイコン」、その他は「企業アイコン」を設定
      icon = level === TREE_LEVEL.OFFICE ? OfficeIcon : CompanyIcon;
      // 選択されたタブが地域階層の場合
    } else if (tabType === HIERARCHY_KBN.AREA) {
      // 最初の階層は「企業アイコン」、2階層目は「地域アイコン」、3階層目は「都道府県アイコン」、その他は「事業所アイコン」を設定
      if (level === TREE_LEVEL.FIRST) {
        icon = CompanyIcon;
      } else if (level === TREE_LEVEL.AREA) {
        icon = AreaIcon;
      } else if (level === TREE_LEVEL.PREF) {
        icon = PrefIcon;
      } else {
        icon = OfficeIcon;
      }
    }

    // ----------------------- 項目名編集 -----------------------
    // 項目名の変数定義
    let itemName;

    if (tabType === HIERARCHY_KBN.COMPANY) {
      // 選択されたタブが企業階層超の場合
      if (level === TREE_LEVEL.FIRST) {
        // 階層が第一階層の場合、商号を表示
        itemName = item.trade_informal_name;
      } else {
        // その他の場合、事業所名を表示
        itemName = item.office_name;
      }
    } else if (tabType === HIERARCHY_KBN.FUND) {
      // 選択されたタブが出資率50%超の場合
      if (level === TREE_LEVEL.OFFICE) {
        // 階層が事業所の場合、事業所名を表示
        itemName = item.office_name;
      } else {
        // 階層が事業所以外の場合、商号を表示
        itemName = item.trade_informal_name;
      }
    } else if (tabType === HIERARCHY_KBN.AREA) {
      // 選択されたタブが地域階層の場合
      if (level === TREE_LEVEL.FIRST) {
        // 階層が第一階層の場合、商号を表示
        itemName = item.trade_informal_name;
      } else if (level === TREE_LEVEL.AREA) {
        // 階層が地域の場合、地域名を表示
        itemName = item.area_name;
      } else if (level === TREE_LEVEL.PREF) {
        // 階層が都道府県の場合、都道府県名を表示
        itemName = item.prefectures_name;
      } else {
        // その他の場合、事業所名を表示
        itemName = item.office_name;
      }
    }

    // ----------------------- 取引情報リンク -----------------------
    // 取引情報リンク
    let additionalItem = null;

    // ラベル取得
    const companyDetailButton = contractLabel?.contract_label_list.filter(
      (i) => i?.label_code === CONTRACT_LABEL.COMPANY_DETAIL_BUTTON,
    );

    // 取引情報有無が存在する、かつフラグONの場合、取引情報リンクを表示
    // 取引情報有無が存在する、かつ
    // それ以外の場合、取引情報リンクを表示しない
    if (item.trade_flag && item.trade_flag === EXISTS.FOUND) {
      additionalItem = (
        <span className="additionalitem">
          <span
            className="additionalitemlink"
            onClick={(e) => {
              e.stopPropagation();
              this.onClickAdditionalItem(item);
            }}
          >
            {companyDetailButton ? companyDetailButton[0]?.label : ''}
          </span>
        </span>
      );
    }

    // ----------------------- 項目名に付与する子会社数編集 -----------------------
    let subsidiaryCount = null;
    // 子会社数が存在しない場合、何も表示しない
    if (item.subsidiary_count
      && !Number.isNaN(Number(item.subsidiary_count))
      && Number(item.subsidiary_count) > 0) {
      subsidiaryCount = (
        <span className="subsidiaryCount">
          {`${Number(item.subsidiary_count).toLocaleString()}`}
        </span>
      );
    }

    // ----------------------- 項目名に付与する事業所数編集 -----------------------
    let officeCount = null;
    let dispOfficeCount = null;
    // 選択タブが地域階層の場合
    if (tabType === HIERARCHY_KBN.AREA) {
      if (level === TREE_LEVEL.FIRST && item.office_count) {
        officeCount = item.office_count;
      } else if (level === TREE_LEVEL.AREA && item.area_office_count) {
        officeCount = item.area_office_count;
      } else if (level === TREE_LEVEL.PREF && item.prefectures_office_count) {
        officeCount = item.prefectures_office_count;
      }
      // 選択タブが地域階層以外の場合
    } else if (item.office_count) {
      officeCount = item.office_count;
    }
    // 事務所数が存在しない場合は何も表示しない
    if (officeCount
      && !Number.isNaN(Number(officeCount))
      && Number(officeCount) > 0) {
      let officeOCIcon = null;
      if (tabType === HIERARCHY_KBN.FUND) {
        officeOCIcon = (
          <div className="officecounticon">
            {officeOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon /> }
          </div>
        );
        dispOfficeCount = (
          <div className="jigyosyoCount" onClick={this.onClickOffice.bind(this, item.kigyo_code, level)}>
            <Grid container justifyContent="space-around">
              事業所数
              <div className="officecountnum">
                {Number(officeCount).toLocaleString()}
              </div>
              {officeOCIcon}
            </Grid>
          </div>
        );
      } else if (tabType === HIERARCHY_KBN.AREA) {
        dispOfficeCount = (
          <div className="jigyosyoCount">
            <Grid container justifyContent="space-around">
              事業所数
              <div className="officecountnum">
                {Number(officeCount).toLocaleString()}
              </div>
              <div className="emptyspace" />
            </Grid>
          </div>
        );
      }
    }

    // ----------------------- 選択中企業、事業所の判定 -----------------------
    let selectCompanyClassName = null;

    // 親企業の判定
    if (tabType === HIERARCHY_KBN.FUND
      && item.office_code === selectedCompanyInfo.kigyo_code) {
      selectCompanyClassName = 'selectKigyo';
    } else if (tabType === HIERARCHY_KBN.AREA
      && (level === TREE_LEVEL.FIRST)) {
      selectCompanyClassName = 'selectKigyo';
    }

    if (selectedCompanyInfo.id) {
      // ツリーから企業が選択されている場合、IDを比較
      if (id === selectedCompanyInfo.id) {
        selectCompanyClassName = 'select';
      }
    } else if (tabType === HIERARCHY_KBN.FUND
      && item.office_code === selectedCompanyInfo.office_code) {
      // 選択タブが出資率50%超の場合、事業所コードを比較
      selectCompanyClassName = 'select';
    } else if (tabType !== HIERARCHY_KBN.FUND
      && level === TREE_LEVEL.FIRST
      && item.office_code === selectedCompanyInfo.office_code) {
      // 選択タブが出資率50%超以外の場合、最初の階層の事業所コードを比較
      selectCompanyClassName = 'select';
    }

    // ----------------------- 企業名の設定 -----------------------
    let tradeName = item.trade_name;
    // 地域階層タブかつ階層が地域または都道府県の場合
    if (tabType === HIERARCHY_KBN.AREA
      && (level === TREE_LEVEL.AREA || level === TREE_LEVEL.PREF)) {
      // 選択中企業名を設定
      tradeName = selectedCompanyInfo.trade_name;
    }

    let childOpenClassName = null;
    if (tabType === HIERARCHY_KBN.AREA) {
      childOpenClassName = childOpen && childList ? `area${level}` : `area${level} none`;
    } else {
      childOpenClassName = childOpen && childList ? `level${level}` : `level${level} none`;
    }

    return (
      <li className={childOpenClassName}>
        <div className={`${selectCompanyClassName} item`}>
          {childList && (
            <div
              className="treeicon"
              onClick={this.onClickChild.bind(this)}
            >
              {childOpen
                ? <IconButton size="small" color="secondary" onClick={() => this.onClickChild.bind(this)} tabIndex="-1"><IndeterminateCheckBoxOutlined /></IconButton>
                : <IconButton size="small" color="secondary" onClick={() => this.onClickChild.bind(this)} tabIndex="-1"><AddBoxOutlined /></IconButton>}
            </div>
          )}
          {childOpen
            ? <div className="emptyBorderLeft" />
            : null}
          {item.kigyo_code === item.office_code ? !childList && (
            <div className="emptyBorderBottom" />
          ) : ''}
          {icon && (
            <div className="icon nonact">
              <img alt="icon" src={icon} />
            </div>
          )}
          <Grid container className="padding">
            <div
              className={`${selectCompanyClassName} companyname`}
              onClick={(ev) => setSelectTreeItem(ev)}
              // データ属性に企業情報を設定
              data-company-duns={item.duns}
              data-kigyo-code={item.kigyo_code}
              data-office-code={item.office_code}
              data-company-trade-name={tradeName}
              data-id={id}
            >
              {itemName}
              {subsidiaryCount}
              {additionalItem}
            </div>
          </Grid>
          {dispOfficeCount}
        </div>
        {officeOpen && officeList}
        {childOpen && childList}
      </li>
    );
  }
}

export default connect(
  (state) => ({
    userInfo: state.common.userInfo,
    contractLabel: state.common.contractLabel,
  }),
)(CompanyTreeItemComponent);
